"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MediaServicesOpenMediaviewerIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m14 11.41-3 3V18h3v2H6.01A2 2 0 0 1 4 17.99V10h2v3h3.59l3-3H12c-.55 0-1-.44-1-1 0-.55.44-1 1-1h3a1 1 0 0 1 1 1v3c0 .55-.44 1-1 1-.55 0-1-.44-1-1zM16 18v2h2c1.11 0 2-.89 2-2v-2h-2v1.5c0 .27-.22.5-.5.5zM8 6V4H6a2 2 0 0 0-2 2v2h2V6.5c0-.27.23-.5.5-.5zm10 2h2V6c0-1.11-.89-2-2-2h-2v2h1.5c.28 0 .5.23.5.5zm-8-4h4v2h-4zm8 6h2v4h-2z"/></svg>`
}, props));
MediaServicesOpenMediaviewerIcon.displayName = 'MediaServicesOpenMediaviewerIcon';
var _default = exports.default = MediaServicesOpenMediaviewerIcon;